import React from 'react';
import { Link } from 'react-router-dom';
import { BookmarkIcon, StarIcon } from '../shared/Icons';
import { formatStudioRoomTitle } from '../../lib/spaceDisplay';

type HomeSpaceCardProps = {
  detailPath?: string;
  image: string;
  location: string;
  price: string;
  priceSuffix?: string;
  rating: string;
  studio: string;
  subtitle: string;
  title: string;
};

function normalizePrice(price: string, suffix: string | undefined) {
  const cleanPrice = price.trim();
  const unitPattern = /\s*\/\s*(?:\d+\s*분|시간|ONE_HOUR|[0-9]+MIN)\s*$/i;
  return {
    price: cleanPrice.replace(unitPattern, ''),
    suffix: suffix ?? '/시간',
  };
}

export function HomeSpaceCard(props: HomeSpaceCardProps) {
  const studio = props.studio.trim();
  const displayTitle = formatStudioRoomTitle(studio, props.title);
  const showStudioInMeta = Boolean(studio && !displayTitle.includes(studio));
  const price = normalizePrice(props.price, props.priceSuffix);

  const cardContent = (
    <>
      <div className="home-space-card__image-wrap">
        {props.image ? <img alt="" className="home-space-card__image" src={props.image} /> : <div className="home-space-card__image home-space-card__image--placeholder" />}
        <BookmarkIcon />
      </div>
      <div className="home-space-card__body">
        <h3 className="home-space-card__title">{displayTitle}</h3>
        <div className="home-space-card__rating">
          <span className="home-meta__group">
            <StarIcon />
            <span className="home-space-card__rating-number">{props.rating}</span>
          </span>
          <span className="home-space-card__location">{props.location}</span>
        </div>
        <div className="home-space-card__bottom">
          <div className="home-space-card__price">
            <strong>{price.price}</strong>
            {price.suffix ? <span>{price.suffix}</span> : null}
          </div>
          <p className="home-space-card__tags">주차가능 · 예약가능</p>
        </div>
        {props.subtitle ? (
          <p className="home-space-card__meta">
            {props.subtitle} {showStudioInMeta ? <><span className="home-space-card__dot" /> {studio}</> : null}
          </p>
        ) : null}
      </div>
    </>
  );

  if (props.detailPath) {
    return (
      <Link className="home-space-card home-space-card__link" to={props.detailPath}>
        {cardContent}
      </Link>
    );
  }

  return (
    <article className="home-space-card">
      {cardContent}
    </article>
  );
}
